import React, { Fragment } from 'react';

import { useViewModel } from './useViewModel';

/**
 * PersonalisationProgressBar component displays the progress bar for the personalisation journey.
 *
 * @param {Object} props - Component props
 * @param {number} props.totalSteps - Total number of steps
 * @param {number} props.currentStep - Current step index
 * @param {boolean} props.isResetting - Whether the progress bar is resetting
 * @returns {import('react').JSX.Element | null}
 */
export function PersonalisationProgressBar({ totalSteps, currentStep, isResetting }) {
  const { stepsArray, getStepStatus, progressBarClassName, stepIndicatorClassName, lineClassName } = useViewModel({
    totalSteps,
    currentStep,
    isResetting
  });

  if (totalSteps < 2) return null;

  return (
    <div className={progressBarClassName} role="navigation" aria-label="Progress">
      {stepsArray.map((_, index) => {
        const status = getStepStatus(index);
        return (
          <Fragment key={index}>
            <div className={stepIndicatorClassName(status)} />
            {index < stepsArray.length - 1 && <div className={lineClassName(index)} />}
          </Fragment>
        );
      })}
    </div>
  );
}
